import React from 'react'

export const LINKS = [
  {
    title: 'Services',
    link: `/services`
  },

  {
    title: 'Solutions',
    link: `/solutions`
  },

  {
    title: 'Market',
    link: '/market'
  },

  {
    title: 'Gallery',
    link: '/company/gallery'
  },

  {
    title: 'Contact Us',
    link: '/contact-us'
  },

  {
    title: 'Get a Quote',
    link: '/company/get-a-quote'
  }
]

export const OTHERS = [
  {
    title: 'GSA Advantage',
    link: 'https://www.gsaadvantage.gov/advantage/ws/catalog/contractor_detail?mapName=/catalog/product_detail&oid=684759945&contractNumber=GS-03F-105AA'
  
  
  },

  {
    title: 'CMAS',
    link: `https://www.dgsapps.dgs.ca.gov/PD/CMASSearch/Default.aspx`
  },

  {
    title: 'California eProcure',
    link: `https://www.caleprocure.ca.gov/pages/index.aspx`
  },
]

export const LOCATIONS_FIRST = [
  {
    title: 'Los Angeles',
  },

  {
    title: 'San Francisco',
  },

  {
    title: 'Phoenix',
  },

  {
    title: 'Chicago',
  },

  {
    title: 'Dallas',
  },
]

export const LOCATIONS_SECOND = [

  {
    title: 'Washington D.C.',
  },

  {
    title: 'Orlando',
  },

  {
    title: 'Atlanta',
  },

  {
    title: 'Las Vegas',
  },


  {
    title: 'Seattle',
  },


]

export const CONNECT_US = [
  {
    logo: <svg x="0px" y="0px" width="1rem" height="1rem" viewBox="0 0 430.113 430.114">
      <path id="Facebook" fill="#FFF" d="M158.081,83.3c0,10.839,0,59.218,0,59.218h-43.385v72.412h43.385v215.183h89.122V214.936h59.805   c0,0,5.601-34.721,8.316-72.685c-7.784,0-67.784,0-67.784,0s0-42.127,0-49.511c0-7.4,9.717-17.354,19.321-17.354   c9.586,0,29.818,0,48.557,0c0-9.859,0-43.924,0-75.385c-25.016,0-53.476,0-66.021,0C155.878-0.004,158.081,72.48,158.081,83.3z" /></svg>,
    link: 'https://www.facebook.com/EIDIMGroup/'
  },

  {
    logo: <svg x="0px" y="0px" viewBox="0 0 512 512" width="1rem" height="1rem" fill="#FFF">
      <path d="M352,0H160C71.648,0,0,71.648,0,160v192c0,88.352,71.648,160,160,160h192c88.352,0,160-71.648,160-160V160
       C512,71.648,440.352,0,352,0z M464,352c0,61.76-50.24,112-112,112H160c-61.76,0-112-50.24-112-112V160C48,98.24,98.24,48,160,48
       h192c61.76,0,112,50.24,112,112V352z"/>
      <path d="M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,336
       c-44.096,0-80-35.904-80-80c0-44.128,35.904-80,80-80s80,35.872,80,80C336,300.096,300.096,336,256,336z"/>
      <circle cx="393.6" cy="118.4" r="17.056" /></svg>,
    link: 'https://www.instagram.com/eidimgroup/'
  },

  {
    logo: <svg x="0px" y="0px" width="1rem" height="1rem" fill="#FFF" viewBox="0 0 430.117 430.117" >
      <path id="LinkedIn" d="M430.117,261.543V420.56h-92.188V272.193c0-37.271-13.334-62.707-46.703-62.707
     c-25.473,0-40.632,17.142-47.301,33.724c-2.432,5.928-3.058,14.179-3.058,22.477V420.56h-92.219c0,0,1.242-251.285,0-277.32h92.21
     v39.309c-0.187,0.294-0.43,0.611-0.606,0.896h0.606v-0.896c12.251-18.869,34.13-45.824,83.102-45.824
     C384.633,136.724,430.117,176.361,430.117,261.543z M52.183,9.558C20.635,9.558,0,30.251,0,57.463
     c0,26.619,20.038,47.94,50.959,47.94h0.616c32.159,0,52.159-21.317,52.159-47.94C103.128,30.251,83.734,9.558,52.183,9.558z
      M5.477,420.56h92.184v-277.32H5.477V420.56z"/></svg>,
    link: 'https://www.linkedin.com/company/eidim-audiovisual-technology/'
  }
]